import { getWeekByDate } from 'app/utils/weekByDate';
import { errorService } from 'global/services';
import { getPeriodsErrorMessage } from './idResolvers.utils';

// Вспомогательная функция для деталей даты

const getDateDetails = (dateStr) => {
    const date = new Date(dateStr);
    return {
        input: dateStr,
        parsedISO: date.toISOString(),
        parsedLocal: date.toString(),
        parsedUTC: date.toUTCString(),
        components: {
            year: date.getFullYear(),
            month: date.getMonth(),
            day: date.getDate(),
            hours: date.getHours(),
            dayOfWeek: date.getDay(),
        },
        utcComponents: {
            year: date.getUTCFullYear(),
            month: date.getUTCMonth(),
            day: date.getUTCDate(),
            hours: date.getUTCHours(),
            dayOfWeek: date.getUTCDay(),
        },
        timestamp: date.getTime(),
        timezoneOffset: date.getTimezoneOffset(),
    };
};

// Информация о окружении
const getEnvironmentInfo = () => ({
    userAgent: navigator?.userAgent,
    platform: navigator?.platform,
    language: navigator?.language,
    timezone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone,
    url: window?.location?.href,
    cookiesEnabled: navigator?.cookieEnabled,
    // Добавляем информацию о функции (для проверки версии)
    functionSource: `${getWeekByDate.toString().substring(0, 200)}...`,
});

const originalGetWeekByDate = getWeekByDate.toString();

export const preparePeriodsId = (responseObject) => {
    const { start, end, __typename } = responseObject;

    const startWeek = getWeekByDate(start);
    const endWeek = getWeekByDate(end);

    if (startWeek !== endWeek) {
        // Детальная диагностика
        const debugInfo = {
            // Основные данные
            start,
            end,
            startWeek,
            endWeek,
            __typename,

            // Детали парсинга дат
            startDateDetails: getDateDetails(start),
            endDateDetails: getDateDetails(end),

            // Информация о окружении
            environment: getEnvironmentInfo(),

            // Временные метки
            timestamp: new Date().toISOString(),
            version: '1.0.2',
        };

        // eslint-disable-next-line no-console
        // console.error('Week calculation mismatch:', debugInfo);

        // errorService.log({
        //     text: `UPD NPM 1.0.4: Поля start: ${start} и end: ${end} имеют разные недели. Start: ${startWeek}, End: ${endWeek}`,
        //     source: 'server',
        //     extra: debugInfo,
        // });
    }

    return `${__typename}:${startWeek}`;
};

